import { ArrowLeft, ArrowRight } from "lucide-react";

import ButtonV2 from "../../../components/ui/button/v2";

type StepNavigationProps = {
    onNext: () => void;
    onPrevious?: () => void; 
    isLast?: boolean;        
    disabled?: boolean;    
};

const StepNavigation: React.FC<StepNavigationProps> = ({ onNext, onPrevious, isLast, disabled }) => (
    <div className="flex justify-between mt-4">
        <ButtonV2
            variant="secondary"
            onClick={(e) => { e.preventDefault(); onPrevious?.(); }}
            disabled={!onPrevious || disabled}
            prefix={<ArrowLeft width="16" height="16" />}
        >
            Previous
        </ButtonV2>
        <ButtonV2
            variant="primary"
            onClick={(e) => { e.preventDefault(); onNext(); }}
            suffix={<ArrowRight width="16" height="16" />}
            disabled={disabled}
        >
            {isLast ? "Submit" : "Next"}
        </ButtonV2>
    </div>
);

export default StepNavigation;
